import React, { useState, useEffect } from "react";
import "./UpgradeSubscriptionModal.css";
import EnterpriseContactModal from "../EnterpriseContactModal/EnterpriseContactModal";

const UpgradeSubscriptionModal = ({ message, onClose }) => {
  const [showUpgradeButton, setShowUpgradeButton] = useState(false);
  const [showLoginButton, setShowLoginButton] = useState(false);
  const [showEnterpriseModal, setShowEnterpriseModal] = useState(false);

  useEffect(() => {
    setShowUpgradeButton(
      message ===
        "You have reached your 5 search limit for our Beta version.  We will contact you soon, we hope, when subscription options for the premium (unlimited search) upgrade are available."
    );

    setShowLoginButton(
      message ===
        "You have reached your search limit. Please sign up or login to continue."
    );
  }, [message]);

  const handleUpgradeClick = () => {
    onClose();
    setShowEnterpriseModal(true);
  };

  const handleLoginClick = () => {
    // Remove free search allowance
    localStorage.setItem("SearchRemaining", "0");
    const currentPath = window.location.pathname + window.location.search;
    const redirectUrl = `/login?redirect=${encodeURIComponent(currentPath)}`;
    // Redirect to login with current path preserved
    window.location.href = redirectUrl;
  };

  return (
    <div className="upgrade-modal-overlay" onClick={onClose}>
      <div
        className="upgrade-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="upgrade-modal-header">
          <h3>Alert</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="upgrade-modal-body">
          <p>{message}</p>
        </div>
        {showUpgradeButton && (
          <div className="upgrade-modal-footer">
            <button onClick={handleUpgradeClick}>Upgrade Plan</button>
          </div>
        )}
        {showLoginButton && (
          <div className="upgrade-modal-footer">
            <button onClick={handleLoginClick}>Login</button>
          </div>
        )}
      </div>
      {showEnterpriseModal && (
        <EnterpriseContactModal onClose={() => setShowEnterpriseModal(false)} />
      )}
    </div>
  );
};

export default UpgradeSubscriptionModal;
